import _ from 'lodash'

export function bookingFields () {
    const form = document.querySelector('.bookly-form')

    if (form) {
        const category = document.querySelectorAll('.bookly-js-select-category')
        const service = document.querySelectorAll('.bookly-js-select-service')

        if (!(category.length && service.length)) {
            setTimeout(() => bookingFields(), 500)
            return
        } else {
            _.each(service, el => { el.setAttribute('disabled', true) })
            _.each(category, el => {
                el.addEventListener('change', e => {
                    if (e.target.value) {
                        _.each(service, el => { el.removeAttribute('disabled') })
                    } else {
                        _.each(service, el => { el.setAttribute('disabled', true) })
                    }
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./mtwp/Theme/Js/Booking/index.js